export default __webpack_public_path__ + "static/bangladeshHeader-e7200d8fd9b272417f60c08a234a0fef.jpg";